// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => ("static/js/" + chunkId + "." + {"732":"9f15b9f9","977":"faf05653"}[chunkId] + ".chunk.js");